import React from "react";
import { AbsoluteFill } from "../AbsoluteFill";
import { HeartIcon } from "../shared/Icons";

export const RedHeart = () => {
  return (
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <HeartIcon size={48} color="#e53e3e" />
    </AbsoluteFill>
  );
};
